import { Controller } from "@hotwired/stimulus"

// onMostra di AnalisiInfo (components/readiness/AnalisiInfo.js): «Apri» di un'analisi precedente e «Torna all'ultima
// analisi» emettono "analisi-info:mostra" (risale il DOM) con { id, kind, testid }: `id` dell'analisi dello storico da
// mostrare al posto dell'ultima, null per tornare all'ultima. Il pannello della scheda che lo ascolta
// (data-action="analisi-info:mostra->…") rende di nuovo il risultato scelto. L'id arriva dal browser: il server lo
// risolve SOLO con AnalisiOperations#analisi_storico_voce(ctx, project_id, id, kind:, grant_id:) (project_access, poi
// progetto + organizzazione + tipo + bando, 404 altrimenti; il risultato torna con "_storico" => true), mai con
// AnalisiStorico.find(id). Meglio un solo controller d'ascolto condiviso dalle schede che una copia per pannello.
//   <div data-controller="analisi-info" data-analisi-info-kind-value="readiness" data-analisi-info-testid-value="readiness-analisi">
//     <button data-action="analisi-info#apri" data-analisi-info-id-param="{id}">Apri</button>
export default class extends Controller {
  static values = { kind: String, testid: String }

  apri({ params: { id } }) {
    this.mostra(id || null)
  }

  torna() {
    this.mostra(null)
  }

  mostra(id) {
    this.dispatch("mostra", { detail: { id, kind: this.kindValue, testid: this.testidValue } })
  }
}
